module.exports = __webpack_public_path__ + "img/27_57.2f2d86d7.png";